import { IconButton as CssModulesIconButton, IconButtonProps } from '@sunwebgroup/uds-ui/icon-button'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/icon-button' instead.
 */
const IconButton = styled(CssModulesIconButton)<IconButtonProps>``
Object.assign(IconButton, { displayName: 'IconButton' })

export default IconButton
